import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'vip-search-menu-skeleton',
    templateUrl: './search-menu-skeleton.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchMenuSkeletonComponent {}
